import "../css/style.scss";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

/*---------top-level-comment---------------------------------------
import plugins
-----------------------*/
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)
gsap.registerPlugin(Observer)
gsap.registerPlugin(ScrollToPlugin)

/*---------top-level-comment---------------------------------------
Custom Easing
-----------------------------------------------------------------*/
CustomEase.create("float", "M0,0 C0.126,0.382 0.18,0.874 0.338,1.022 0.53,1.202 0.637,0.935 1,1");
CustomEase.create("mutedFloat", "M0,0 C0.063,0.191 0.199,0.822 0.272,0.986 0.345,1.15 0.497,1.015 0.633,1 0.493,0.981 0.818,1.001 1,1 ");
CustomEase.create("slowly", "M0,0 C0.176,0.039 0.228,0.039 0.394,0.131 0.486,0.182 0.564,0.297 0.647,0.47 0.694,0.569 0.686,0.53 0.739,0.688 0.783,0.822 0.822,1.014 1,1")
var bezierSoft = 'cubic-bezier(0.87, 0, 0.13, 1)';
var bezierFloat = 'cubic-bezier(.17,1.74,.57,.88)';

/*---------top-level-comment---------------------------------------
Patient Stories Popup
-----------------------------------------------------------------*/
let storyPopupTriggers, storyPopupTriggersMobile, storyPopups, storyPopupsInners, storyCloseTriggers;
document.addEventListener('DOMContentLoaded', ()=> {
    storyPopupTriggers = document.querySelectorAll('.patient-stories .swiper .read-more');
    storyPopupTriggersMobile = document.querySelectorAll('.patient-stories .mobile .read-more');
    storyPopups = document.querySelectorAll('.story-popup');
    storyPopupsInners = document.querySelectorAll('.story-popup .popup-inner');
    storyCloseTriggers = document.querySelectorAll('.story-popup .close-trigger');

    attach_storyPopupTrigger();

    storyCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', ()=> closeStoryPopup())
    })
})

function attach_storyPopupTrigger() {
    let type;
    storyPopupTriggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => storyPopupTrigger_fnc(event, type='desktop'))
    })
    storyPopupTriggersMobile.forEach(trigger => {
        trigger.addEventListener('click', (event) => storyPopupTrigger_fnc(event, type='mobile'))
    })
}

function storyPopupTrigger_fnc(event, type) {
    let clicked_index;
    if (type === 'desktop') {
        clicked_index = Array.from(storyPopupTriggers).indexOf(event.currentTarget);
    }
    if (type === 'mobile') {
        clicked_index = Array.from(storyPopupTriggersMobile).indexOf(event.currentTarget);
    }
    openStoryPopup(clicked_index);
}
function openStoryPopup(index) {
    console.log('length of storyPopupTriggers', storyPopupTriggers.length);

    console.log('index', index);

    const popupInner = storyPopups[index].querySelector('.popup-inner');
    gsap.to(popupInner, {
        display: 'flex',
        autoAlpha: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.inOut'
    })
    gsap.to(storyPopups[index], {
        display: 'flex',
        autoAlpha: 1,
        duration: 0.6,
        delay: 0.3,
        ease: 'power4.out'
    })
}
function closeStoryPopup() {
    gsap.to(storyPopups, {
        display: 'none',
        autoAlpha: 0,
        duration: 0.4,
        delay: 0.3,
        ease: 'power2.inOut'
    })
    gsap.to(storyPopupsInners, {
        display: 'none',
        autoAlpha: 0,
        y: -15,
        duration: 0.4,
        ease: 'power4.inOut'
    })
}

/*---------top-level-comment---------------------------------------
Book Popup Functionality
-----------------------------------------------------------------*/
let bookPopup, bookBtns, bookPopupCloseTriggers, bookPopupInner;

document.addEventListener('DOMContentLoaded', ()=> {
    bookBtns = document.querySelectorAll('.book-popup-trigger');
    bookPopup = document.querySelector('.book-popup');
    bookPopupInner = document.querySelector('.book-popup .popup-inner');
    bookPopupCloseTriggers = document.querySelectorAll('.book-popup .close-trigger');
    attach_bookBtn_evtL();
})

function attach_bookBtn_evtL() {
    bookBtns.forEach(btn => bookBtn_evtL(btn));
    bookPopupCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', ()=> closeBookPopup())
    })
}

function bookBtn_evtL(btn) {
    btn.addEventListener('click', ()=> openBookPopup());
}

function openBookPopup() {
    gsap.to(bookPopupInner, {
        display: 'flex',
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.inOut'
    })
    gsap.to(bookPopup, {
        display: 'flex',
        autoAlpha: 1,
        duration: 0.1,
        ease: 'power2.inOut'
    })
}

function closeBookPopup() {
    gsap.to(bookPopup, {
        display: 'none',
        autoAlpha: 0,
        duration: 0.3,
        ease: 'power2.inOut'
    })
    gsap.to(bookPopupInner, {
        display: 'none',
        autoAlpha: 0,
        y: -15,
        duration: 0.3,
        ease: 'power2.inOut'
    })
}